import { Injectable } from '@angular/core';
import { BaseRepository } from "./base.repository";
import { HttpClient } from "@angular/common/http";
import {StatisticPayload} from "../../services/wrapper/restaurant-statistics.service";

@Injectable({
  providedIn: 'root'
})
export class RestaurantStatisticsRepository extends BaseRepository {

  private readonly staffPath;

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.staffPath = 'dashboard/staff/statistics';
  }

  getStatistics(payload: StatisticPayload) {
    const path = this.staffPath +"/restaurant/"+payload.id
    return super.post(path, payload);
  }
}
